import React from 'react';
import { useTranslation } from 'next-i18next';

import { CartSlot } from 'components/cart';
import { PageSeo } from 'components/common';
import { Layout } from 'components/layout';
import { TRANSLATIONS } from 'constants/translations';
import { getSearchPageSeoProps } from 'helpers/SeoHelpers';
import { prefetchConfig } from 'helpers/ServerHelpers';
import { withSSRPage } from 'hoc/WithServerPage/withSSRPage';
import { prefetchSearchResults } from 'hooks/data/useSearchProducts';
import { prefetchSearchSuggestions } from 'hooks/data/useSearchSuggestions';
import SearchTemplate from 'templates/Search/SearchTemplate';

import styles from 'templates/Search/SearchTemplate.module.scss';

import type { NextPageWithLayout } from 'types';
import { PageType } from 'types';

export const getServerSideProps = withSSRPage(async (context, props) => {

  const { urlParams, queryClient } = props;

  await Promise.all([
    prefetchConfig(queryClient),
    prefetchSearchResults(urlParams.identifier || '', urlParams, queryClient),
    prefetchSearchSuggestions(urlParams.identifier || '', queryClient)
  ]);

  return {
    props: {}
  };

}, {
  translations: [TRANSLATIONS.COMMON],
  pageType: PageType.Search,
});

// --- Page

const Page: NextPageWithLayout<PageType.Search> = (props) => {
  const { urlParams } = props;

  const { t } = useTranslation();

  const pageSeoProps = React.useMemo(() => getSearchPageSeoProps(t, urlParams), [t, urlParams]);

  return (
    <>
      <PageSeo {...pageSeoProps} />
      <SearchTemplate urlParams={urlParams} />
    </>
  );
};

// --- Page Layout

Page.getLayout = (page) => {
  return (
    <Layout
      containerClassName={styles.layoutContainer}
      rightSlot={{ component: CartSlot, props: {} }}
      header={{
        props: {
          hideCartOnLargeScreens: true
        },
        isVisible: true
      }}
    >
      {page}
    </Layout>
  );
};

export default Page;
